import * as Yup from 'yup'

import flow from 'lodash/flow'


import date from '@galo-monitor/forms/validators/date.validator'
import number from '@galo-monitor/forms/validators/number.validator'
import required from '@galo-monitor/forms/validators/required.validator'

const harvestSchema = ({ t }) => Yup.object().shape({
  culture_id: flow(
    number({ t }),
    required({ t })
  )(Yup.string()),
  cultivation_method: required({ t })(Yup.string()),
  name: required({ t })(Yup.string()),
  color: required({ t })(Yup.string()),
  date_initial: flow(
    date({ t }),
    required({ t })
  )(Yup.string()),
  date_finish: flow(
    date({ t }),
    required({ t })
  )(Yup.string()),
  plots: Yup.array().of(
    Yup.object().shape({ id: Yup.number() })
  )
})

export default harvestSchema
